import $ from "jquery";
import "slick-carousel"

const ervaringenSlider = () => {

  const init = () => {
    action();
  };

  const action = () => {
    // const el = {
    //   sliderWrapper : ".js-ervaringen"
    // }

    $(".js-ervaringen").slick({
        dots: true,
        arrows: false,
        // nextArrow: el.buttonNext,
        // prevArrow: el.buttonPrev,
        infinite: false,
        speed: 300,
        centerMode: false,
        // centerPadding: '20px',
        slidesToShow: 1,
        slidesToScroll: 1,
      })
  };

  init();
};

try {
  ervaringenSlider();
} catch (error) {
  throw Error(error);
}

